import { Button, Paper, Typography } from '@mui/material';
import Image from '../../components/Image/Image';

import stringUtils from '../../utils/StringUtils';

import './VectorFocusListItem.scss';

function VectorFocusListItem({ vectorFocus, handleGoToVectorFocusDetails }) {
  const initialPicture = vectorFocus?.picture?.url;
  const address = stringUtils.getPrettyAddress({ 
    city: vectorFocus?.city?.name,
    address: vectorFocus?.address
  });
  const description = vectorFocus?.description;
  const denounceStatusName = stringUtils.getPrettyDenounceStatus(vectorFocus?.denounce_status?.name);
  const createdAt = stringUtils.getPrettyDateTime(vectorFocus?.created_at);
  const updatedAt = stringUtils.getPrettyDateTime(vectorFocus?.updated_at);

  function handleGoToDetails() {
    handleGoToVectorFocusDetails?.(vectorFocus.id);
  }

  return (
    <Paper className="vector-focus-list-item" elevation={2}>
      <div className="header">
        {initialPicture && <Image src={initialPicture} />}
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="p" component="p"><b>Endereço: </b>{address}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="p" component="p"><b>Status: </b>{denounceStatusName}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="p" component="p"><b>Descrição: </b>{description}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="p" component="p"><b>Data de criação: </b>{createdAt}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="p" component="p"><b>Última atualização: </b>{updatedAt}</Typography>
      </div>
      <div className="action-buttons">
        {handleGoToDetails && <Button onClick={handleGoToDetails}>Mais detalhes</Button>}
      </div>
    </Paper>
  );
}

export default VectorFocusListItem;
